import { useForm } from 'react-hook-form';
import { editAdminData } from "../hooks/apiAxios"
import { useAdmin } from "../context/Admins/AdminContext";
import { toast, ToastContainer } from "react-toastify";

import moment from 'moment';
import SuccessErrorMsg from "../utilities/SuccessErrorMsg"
import AdminDashForm from '../features/admin/setting/components/AdminDashForm';

export default function AdminAccount() {
    const { profile, loading, setLoading } = useAdmin();
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();

    moment.locale('en');

    const isoDate = profile?.data?.birthDate;
    // const adminName = profile?.data?.firstName;
    const formattedBirthDate = moment(isoDate).format('YYYY-MM-DD');

    async function onSubmit(formData) {
        setLoading(true);
        try {
            const response = await editAdminData(formData);
            if (response.data.isSuccess) {
                toast.success("تم تحديث ملفك بنجاح ..")
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                toast.error("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.warn("لا توجد صلاحية");
        } finally {
            setLoading(false);
        }
    }

    if (!profile) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    // if (loading) return <div className="text-center my-4 text-danger">هناك مشكلة تواصل مع الدعم</div>;

    return (
        <div className="container mt-2 rounded pb-5 bg-light-gray position-relative">
            <AdminDashForm
                role={profile?.data?.role}
                id={profile?.data?.id}
                adminImage={profile?.data?.image}
                register={register}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                formState={{ errors }}
                setValue={setValue}
                loading={loading}
                formattedBirthDate={formattedBirthDate}
                toast={toast}
                ToastContainer={ToastContainer}
                firstName={profile?.data?.firstName}
                lastName={profile?.data?.lastName}
                email={profile?.data?.email}
                mobilePhone={profile?.data?.mobilePhone}
            />
            <SuccessErrorMsg ToastContainer={ToastContainer} />
        </div>
    )
};